export default __webpack_public_path__ + "static/media/otherfield.4663ae46.png";